module.exports = __webpack_public_path__ + "img/mira-icon.c800d72e.svg";